{
  "behaviorSummaryCard": {
    "ronLikelihood": {
      "label": "RON Likelihood",
      "tooltip": "Probability this aircraft will stay overnight"
    },
    "typicalArrival": {
      "label": "Typical Arrival",
      "tooltip": "Most common arrival time for this aircraft"
    },
    "typicalTurn": {
      "label": "Typical Turn",
      "tooltip": "Average time on ground between arrival and departure",
      "tooltipDetail": "Based on historical flight data"
    },
    "visitTypes": {
      "quickTurn": "Quick Turn",
      "dayStop": "Day Stop",
      "ron": "RON"
    },
    "basedOn": "Based On",
    "title": "Behavior Summary Card"
  },
  "filters": {
    "flightTypes": {
      "all": "All",
      "arrivals": "Arrivals",
      "departures": "Departures"
    },
    "statuses": {
      "scheduled": "Scheduled",
      "active": "Active",
      "landed": "Landed",
      "cancelled": "Cancelled"
    },
    "flags": {
      "vipOnly": "VIP Only",
      "favoritesOnly": "Favorites Only",
      "showIgnored": "Show Ignored"
    },
    "search": {
      "placeholder": "Search flights..."
    },
    "lastUpdated": {
      "neverUpdated": "Never updated",
      "justNow": "Just now",
      "minutesAgo": "Minutes Ago",
      "secondsAgo": "Seconds Ago"
    },
    "dropdowns": {
      "allStatus": "All Status",
      "flags": "Flags",
      "operator": "Operator"
    },
    "myReservations": "My Reservations",
    "liveStatus": "LIVE",
    "arrivingSoon": "Arriving Soon"
  },
  "services": {
    "fuel": "Fuel",
    "hangar": "Hangar",
    "catering": "Catering",
    "hotel": "Hotel",
    "crewCar": "Crew Car",
    "limo": "Limo",
    "carRental": "Car Rental",
    "arrivalLimo": "Arrival Limo",
    "departureLimo": "Departure Limo",
    "deicing": "Deicing",
    "groundPower": "Ground Power",
    "gpu": "GPU",
    "lavatory": "Lavatory",
    "lavService": "Lav Service",
    "water": "Water",
    "towing": "Towing",
    "oxygen": "Oxygen",
    "conferenceRoom": "Conference Room",
    "customs": "Customs",
    "cipService": "CIP Service",
    "payment": "Payment",
    "dishes": "Dishes",
    "linens": "Linens",
    "otherArrival": "Other (Arrival)",
    "otherDeparture": "Other (Departure)"
  },
  "flightRow": {
    "tooltips": {
      "hasReservation": "Has reservation"
    }
  },
  "flightNotes": {
    "defaultTags": {
      "ops": "Ops",
      "fuel": "Fuel",
      "catering": "Catering",
      "hotel": "Hotel",
      "crew": "Crew",
      "vipRequest": "VIP Request",
      "followUp": "Follow-up",
      "urgent": "Urgent"
    },
    "search": {
      "placeholder": "Search notes...",
      "clearSearch": "Clear search",
      "noMatches": "No Matches"
    },
    "emptyState": {
      "title": "No notes yet",
      "message": "Use notes to coordinate with your team about this flight",
      "quickActions": {
        "passengersArrived": {
          "label": "Passengers Arrived",
          "template": "Passengers have arrived",
          "tag": "Ops"
        },
        "fuelCompleted": {
          "label": "Fuel Completed",
          "template": "Fuel service completed",
          "tag": "Fuel"
        },
        "crewCalled": {
          "label": "Crew Called",
          "template": "Crew has been notified",
          "tag": "Crew"
        },
        "ownerRequest": {
          "label": "Owner Request",
          "template": "Owner requested: ",
          "tag": "VIP Request"
        }
      }
    },
    "dateLabels": {
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "composer": {
      "placeholder": "Add a note...",
      "quickTags": "Quick tags",
      "helpText": "Press Enter to submit, Shift+Enter for new line"
    },
    "noteActions": {
      "edited": "edited",
      "cancel": "Cancel"
    },
    "messages": {
      "loadFailed": "Failed to load notes",
      "notePinned": "Note pinned",
      "noteUnpinned": "Note unpinned",
      "updateFailed": "Failed to update note",
      "noteUpdated": "Note updated",
      "noteDeleted": "Note deleted",
      "deleteFailed": "Failed to delete note",
      "noteCopied": "Note copied to clipboard",
      "copyFailed": "Failed to copy note"
    },
    "confirmations": {
      "deleteNote": "Delete this note? This cannot be undone."
    }
  },
  "flightList": {
    "emptyState": {
      "noFlightsFound": "No flights found",
      "tryAdjustingFilters": "Try adjusting your filters"
    }
  },
  "notesDialog": {
    "labels": {
      "vip": "VIP"
    }
  },
  "opsCenterLoading": {
    "logoAlt": "AirPlx Logo",
    "messages": {
      "fetchingOperations": "Fetching operations...",
      "syncingFlightAware": "Syncing with FlightAware...",
      "loadingPositions": "Loading positions...",
      "updatingArrivals": "Updating arrivals...",
      "checkingDepartures": "Checking departures...",
      "pullingTracking": "Pulling tracking data..."
    }
  },
  "tailDetailDrawer": {
    "overallTendencies": {
      "title": "Overall Tendencies",
      "lastDays": "Last Days",
      "subtitle": "Subtitle"
    },
    "estimatedFuel": {
      "label": "Estimated Fuel",
      "tooltip": "Estimated fuel needs based on aircraft type and typical trip distance",
      "low": "Low",
      "high": "High"
    },
    "flightsPerDay": {
      "label": "Flights/Day",
      "tooltip": "Average flight activity for this aircraft",
      "tooltipDetail": "Compared to similar aircraft types",
      "busier": "Busier",
      "quieter": "Quieter"
    },
    "medianStay": {
      "label": "Median Stay",
      "tooltip": "Typical duration this aircraft stays at your FBO",
      "tooltipDetail": "Based on historical visits",
      "shorter": "Shorter",
      "longer": "Longer"
    },
    "ronPercentage": {
      "label": "RON %",
      "tooltip": "Percentage of visits that include an overnight stay",
      "tooltipDetail": "Remain Over Night percentage",
      "quick": "Quick turns",
      "overnight": "Overnight"
    },
    "recentFlights": {
      "noFlights": "No recent flights",
      "tableHeaders": {
        "date": "Date",
        "route": "Route",
        "times": "Times",
        "stay": "Stay",
        "duration": "Duration",
        "status": "Status"
      },
      "lastDays": "Last Days",
      "title": "Recent Flights"
    },
    "prediction": {
      "atAirport": "At Airport",
      "basedOn": "Based On",
      "confidence": "Confidence"
    }
  },
  "tvFooter": {
    "justNow": "Just now",
    "never": "Never",
    "hoursAgo": "Hours Ago",
    "minutesAgo": "Minutes Ago",
    "secondsAgo": "Seconds Ago",
    "updated": "Updated"
  },
  "tvHeader": {
    "live": "LIVE",
    "autoScroll": "Auto Scroll",
    "exitTVMode": "Exit TV Mode",
    "switchToDarkMode": "Switch to Dark Mode",
    "switchToLightMode": "Switch to Light Mode",
    "lastUpdated": "Last Updated"
  },
  "tvModeButton": {
    "tooltip": "Open in TV Mode",
    "dialogTitle": "TV Mode",
    "tvModeLink": "TV Mode Link",
    "helperText": "Open this link on a display to show flight board",
    "activeFilters": "Active Filters",
    "noFilters": "No filters active",
    "filterLabels": {
      "arrivals": "Arrivals only",
      "departures": "Departures only",
      "vipOnly": "VIP only",
      "favoritesOnly": "Favorites only",
      "myReservations": "My reservations",
      "showIgnored": "Including ignored",
      "search": "Search",
      "status": "Status",
      "type": "Type"
    },
    "buttons": {
      "copyLink": "Copy Link",
      "copied": "Copied!",
      "openInNewWindow": "Open in New Window",
      "cancel": "Cancel"
    }
  },
  "alertToast": {
    "relativeTime": {
      "hoursAgo": "Hours Ago",
      "justNow": "Just Now",
      "minutesAgo": "Minutes Ago",
      "oneHourAgo": "One Hour Ago",
      "oneMinuteAgo": "One Minute Ago"
    },
    "unknownAircraft": "Unknown Aircraft"
  },
  "dashboard": {
    "errors": {
      "failedToLoadFlights": "Error: Failed To Load Flights"
    }
  },
  "dataCoverageIndicator": {
    "etaAvailable": "Eta Available",
    "liveTracking": "Live Tracking",
    "noETA": "No E T A",
    "noLiveData": "No Live Data",
    "operatorKnown": "Operator Known",
    "unknownOperator": "Unknown Operator"
  },
  "flightDetailDrawer": {
    "altitudeStates": {
      "climbing": "Climbing",
      "descending": "Descending",
      "level": "Level"
    },
    "buttons": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "fields": {
      "actualIn": "Actual In:",
      "actualOut": "Actual Out:",
      "airport": "Airport:",
      "altitude": "Altitude:",
      "altitudeChange": "Altitude Change:",
      "assignedRampSpot": "Assigned Ramp Spot:",
      "atcCallsign": "Atc Callsign:",
      "code": "Code:",
      "delay": "Delay:",
      "estimatedIn": "Estimated In:",
      "estimatedOut": "Estimated Out:",
      "flightId": "Flight Id:",
      "fuelRequest": "Fuel Request:",
      "groundspeed": "Groundspeed:",
      "hangarRequested": "Hangar Requested:",
      "heading": "Heading:",
      "iata": "Iata:",
      "lastUpdated": "Last Updated:",
      "makeModel": "Make Model:",
      "position": "Position:",
      "progress": "Progress:",
      "registration": "Registration:",
      "scheduledIn": "Scheduled In:",
      "scheduledOut": "Scheduled Out:",
      "status": "Status:",
      "terminalGate": "Terminal Gate:",
      "type": "Type:"
    },
    "formats": {
      "delayMinutes": "Delay Minutes",
      "gate": "Gate",
      "terminal": "Terminal"
    },
    "noFlightSelected": "No Flight Selected",
    "placeholders": {
      "fuel": "Fuel",
      "spot": "Spot"
    },
    "sections": {
      "aircraft": "Aircraft",
      "destination": "Destination",
      "flightInformation": "Flight Information",
      "internalNotes": "Internal Notes",
      "livePosition": "Live Position",
      "operations": "Operations",
      "operator": "Operator",
      "origin": "Origin"
    },
    "units": {
      "degrees": "Degrees",
      "feet": "Feet",
      "knots": "Knots"
    }
  },
  "opsMap": {
    "airport": {
      "code": "Code",
      "name": "Name"
    },
    "emptyState": "Empty State",
    "labels": {
      "eta": "Eta",
      "etd": "Etd",
      "from": "From"
    }
  },
  "otherServicesPopover": {
    "title": "Other Services Popover"
  }
}
